// src/cookies/consent.js
import { getCookie, setCookie } from "../assets/utils/cookies.js";

const CONSENT_COOKIE = "td_cookie_consent_v1";

// Shape we store
const defaultConsent = {
  necessary: true,
  analytics: false,
  marketing: false,
  updatedAt: null,
};

export function readConsent() {
  const raw = getCookie(CONSENT_COOKIE);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return { ...defaultConsent, ...parsed, necessary: true };
  } catch {
    return null;
  }
}

export function writeConsent(consent) {
  const payload = {
    ...defaultConsent,
    ...consent,
    necessary: true,
    updatedAt: new Date().toISOString(),
  };
  setCookie(CONSENT_COOKIE, JSON.stringify(payload), { days: 180, sameSite: "Lax" });
  return payload;
}

// For your app to check
export function hasAnalyticsConsent() {
  const c = readConsent();
  return !!c?.analytics;
}

export function hasMarketingConsent() {
  const c = readConsent();
  return !!c?.marketing;
}
